module.exports = __webpack_public_path__ + "static/media/iconContact2.ca47a27b.svg";